import Page from '@/components/page';
import { KYTE_PRIVACY_POLICY } from '@/config/global-constants';
import useTranslation from '@/hooks/use-translation';
import PDFViewer from '../components/pdf-viewer/pdf-viewer';

const PrivacyPolicy = () => {
  const { t } = useTranslation('pages.docs.privacy-policy');

  return (
    <Page
      title={t('title')}
      top={{
        mobile: 96,
        web: 128,
      }}
    >
      <PDFViewer title={t('title')} pdfUrl={KYTE_PRIVACY_POLICY} />
    </Page>
  );
};

export default PrivacyPolicy;
